import * as S from './style';

interface ProgressBarProps {
  progress: number;
}

export function ProgressBar({ progress }: ProgressBarProps) {
  return (
    <S.Progress>
      <S.ProgressBarWrapper>
        <S.ProgressBar progress={progress}>
          <S.ProgressCount>{progress}%</S.ProgressCount>
        </S.ProgressBar>
      </S.ProgressBarWrapper>
      <S.ProgressText>
        <S.Text>0%</S.Text>
        <S.Text>100%</S.Text>
      </S.ProgressText>
    </S.Progress>
  );
}
